import {Component} from 'react';
import React from 'react';

import Modal from 'react-responsive-modal';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import QRCode from 'qrcode.react';
import Button from "react-bootstrap/es/Button";

class QRCodeDialog extends Component {
    constructor(props) {
        /*
            Props:
             - open
             - title
             - qrCode
             - onClose
             - enableDownload
        */
        super(props);
    }

    render() {
        return (
            <Modal open={this.props.open}
                   styles={{
                       modal: {
                       }
                   }}
                   onClose={this.props.onClose}>
                <h2>{this.props.title ? this.props.title : "QR Code"}</h2>
                {this.props.qrCode==null ? "" : (<div>
                    <a id="qrCodeCanvasWrapper">
                        <QRCode
                            size={256}
                            value={this.props.qrCode}
                            includeMargin={true}
                            id={"qrCodeCanvas"}
                        />
                    </a><br/>
                    {this.props.enableDownload ? (<Button bsStyle={"primary"} onClick={() => {
                        const canvas = document.getElementById("qrCodeCanvas");
                        const uri = canvas.toDataURL("image/png");
                        const wrapper = document.getElementById("qrCodeCanvasWrapper");
                        wrapper.download = "webappQr.png";
                        wrapper.href = uri;
                        wrapper.click();
                        wrapper.removeAttribute("href");
                        wrapper.removeAttribute("download");
                    }}>
                        <i className="fa fa-download"></i> Download
                    </Button>) : ""}
                </div>)}
            </Modal>
        );
    }
}

export default QRCodeDialog;